import styled from "styled-components";
import { ReactComponent as Beds } from "../../../assets/icons/bed.svg";
import { ReactComponent as Bath } from "../../../assets/icons/bath.svg";
import { ReactComponent as Car } from "../../../assets/icons/car.svg";
import { ReactComponent as Ruler } from "../../../assets/icons/ruler.svg";
import { ReactComponent as ReSize } from "../../../assets/icons/resize.svg";
import { ReactComponent as Plus } from "../../../assets/icons/plus.svg";
import { ReactComponent as Heart } from "../../../assets/icons/heart.svg";

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => (width ? width : "345px")};
  height: ${({ height }) => (height ? height : "428px")};
  box-sizing: border-box;
  border: 1px solid #e6e9ec;
  border-radius: 3px;
`;

Wrap.Img = styled.div`
  flex: 1;
  position: relative;

  background: url("https://images.unsplash.com/photo-1592928302636-c83cf1e1c887?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

Wrap.Button = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: ${({ top }) => (top ? top : "")};
  left: ${({ left }) => (left ? left : "")};
  right: ${({ right }) => (right ? right : "")};
  bottom: ${({ bottom }) => (bottom ? bottom : "")};
  width: ${({ width }) => (width ? width : "73px")};
  height: ${({ height }) => (height ? height : "23px")};
  color: ${({ color }) => (color ? color : "#fff")};
  font-size: ${({ size }) => (size ? size : "10px")};
  font-weight: ${({ weight }) => (weight ? weight : "600")};
  border-radius: ${({ radius }) => (radius ? radius : "3px")};
  background: ${({ background }) => (background ? background : "#0D263B")};
  padding: ${({ padding }) => (padding ? padding : "5px 12px")};
  cursor: pointer;
`;
Wrap.HeroImg = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  bottom: -20px;
  right: 20px;
  z-index: 1;
  background: url("https://images.unsplash.com/photo-1592928302636-c83cf1e1c887?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

Wrap.Details = styled.div`
  flex: 1;
  padding: 20px;
`;
Wrap.Title = styled.h2`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;
`;

Wrap.Descrpt = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #696969;
  padding: 9px 0 20px 0;
`;

Wrap.Features = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 20px;
`;
Wrap.Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

Wrap.Beds = styled(Beds)`
  width: 19px;
  height: 19px;
`;

Wrap.Bath = styled(Bath)`
  width: 19px;
  height: 19px;
`;
Wrap.Car = styled(Car)`
  width: 19px;
  height: 19px;
`;
Wrap.Ruler = styled(Ruler)`
  width: 19px;
  height: 19px;
`;
Wrap.ReSize = styled(ReSize)`
  width: 14px;
  height: 14px;
`;
Wrap.Plus = styled(Plus)`
  width: 14px;
  height: 14px;
  margin: 0 20px;
`;
Wrap.Heart = styled(Heart)`
  width: 14px;
  height: 14px;
  margin-right: 20px;
`;

Wrap.Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  padding-top: 15px;
  width: 100%;
  border-top: 1px solid #e6e9ec;
`;

Wrap.Price = styled.h2`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #0d263b;
`;
